import { Grid, Typography, Divider, Box, Paper, Button } from "@mui/material";
import { useIntl } from "react-intl";
import { Spinner } from "react-bootstrap";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DinamicTable from "components/DinamicTable/DinamicTable";

interface Empresas {
  id: number;
}

interface DetalleInventarioProps {
  verEmpresas?: Empresas[] | null;
  procesando: boolean;
  handleisAlertOpenDetalleEmpresa: () => void;
  setVerDetalleEmpresa: React.Dispatch<React.SetStateAction<any>>;
  setVerEditarEmpresa: React.Dispatch<React.SetStateAction<any>>;
  handleisAlertOpenCrearEmpresa: () => void;
  desactivarEmpresa: (datos: any) => Promise<void>;
  activarEmpresa: (datos: any) => Promise<void>;
}

const EmpresasModulo = ({
  verEmpresas,
  procesando,
  handleisAlertOpenDetalleEmpresa,
  setVerDetalleEmpresa,
  handleisAlertOpenCrearEmpresa,
  setVerEditarEmpresa,
  desactivarEmpresa,
  activarEmpresa,
}: DetalleInventarioProps) => {
  if (!verEmpresas) return null;
  const intl = useIntl();

  const getEstado = (estado: number) => {
    switch (estado) {
      case 1:
        return "success";
      case 0:
        return "error";
      default:
        return "default";
    }
  };

  const estadosMap: { [key: number]: string } = {
    1: "ACTIVADO",
    0: "DESACTIVADO",
  };

  const traducirEstado = (estado: number | null): string => {
    if (estado === null || estado === undefined) return "SIN ESTADO";
    return estadosMap[estado] ?? "SIN ESTADO";
  };

  return (
    <Box sx={{ px: 2, pb: 2, mt: 3 }}>
      <Grid container spacing={3}>
        {/* Información de la talla */}
        <Grid item xs={12}>
          <Paper elevation={2} sx={{ p: 2 }}>
            <Grid container>
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: { xs: "center", sm: "end" },
                }}
              >
                <Button
                  sx={{ color: "#fff", background: "#041d45" }}
                  variant="contained"
                  endIcon={<AddBoxIcon />}
                  onClick={(e: any) => {
                    setVerEditarEmpresa(null);
                    handleisAlertOpenCrearEmpresa();
                  }}
                >
                  {intl.formatMessage({ id: "nueva_empresa" })}
                </Button>
              </Grid>
            </Grid>
            <Divider sx={{ m: 2 }} />
            {verEmpresas.length > 0 ? (
              <>
                <DinamicTable
                  key={"tabla-empresa"}
                  sinExport
                  canSearch
                  columnsOrder={[
                    //"id",
                    "nombre",
                    "razon_social",
                    "contacto",
                    "rfc",
                    "estatus",
                  ]}
                  data={verEmpresas}
                  esListaEmpresas
                  actions
                  enAccion={(accion, row) => {
                    const datos = {
                      id_empresa: row.id,
                    };
                    if (accion === "ver") {
                      setVerDetalleEmpresa(row);
                      handleisAlertOpenDetalleEmpresa();
                    }
                    if (accion === "editar") {
                      setVerEditarEmpresa(row);
                      handleisAlertOpenCrearEmpresa();
                    }
                    if (accion === "activar") {
                      activarEmpresa(datos);
                    }
                    if (accion === "desactivar") {
                      desactivarEmpresa(datos);
                    }
                  }}
                />
              </>
            ) : procesando ? (
              <Box sx={{ textAlign: "center", py: 4 }}>
                <Typography variant="h6" color="text.secondary">
                  {intl.formatMessage({ id: "general_cargando_datos" })}
                </Typography>
                <Spinner animation="border" />
              </Box>
            ) : verEmpresas?.length === 0 && !procesando ? (
              <Box sx={{ textAlign: "center", py: 2 }}>
                <Typography variant="h6" color="text.secondary">
                  {intl.formatMessage({ id: "no_hay_datos_registrados" })}
                </Typography>
              </Box>
            ) : null}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};
export default EmpresasModulo;
